<template>
  <div v-if="record.type && record.type === 'adv'">
    <slot name="adv" />
  </div>
  <personal-selection-item
    v-else
    :record="record"
    @recordShown="emitRecordShow"
    @recordClicked="emitRecordClick"
  />
</template>

<script>
import PersonalSelectionItem from '../personal-selection-item/personal-selection-item.component.vue';

export default {
  name: 'PersonalSelectionABCPlace',
  components: {
    PersonalSelectionItem
  },
  props: {
    record: {
      type: Object,
      required: true
    },
    placeNumber: {
      type: Number,
      required: true
    }
  },
  methods: {
    emitRecordClick() {
      this.$emit('recordClicked');
    },
    emitRecordShow() {
      this.$emit('recordShown');
    }
  }
};
</script>
